import { render, staticRenderFns } from "./ModalUpdateForm.vue?vue&type=template&id=50271650"
import script from "./ModalUpdateForm.vue?vue&type=script&lang=ts"
export * from "./ModalUpdateForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports